/* Malichus encyclopedia - layout & identity polish layer (additive, draft theme only) */
(function(){
var CSS=[
/* 1. full-width reading: the page and the story modal both stop fighting the viewport */
"#mz{max-width:none!important;padding-left:clamp(18px,3vw,56px)!important;padding-right:clamp(18px,3vw,56px)!important}",
"#mz .mz-reading,#mz .mz-reader-head,#mz .mz-reader-next,#mz .mz-reader-sheet,#mz .mz-bm{max-width:none!important}",
"#mz .mz-reading p,#mz .mz-reading li,#mz .mz-reading dd{max-width:85ch!important}",
"#mz-modal .mz-reader-sheet{width:100vw!important;max-width:none!important;border-radius:0!important}",
/* 2. directory search box: flex-basis was being read as a height inside a column flex label */
"#mz .mz-directory-controls label{align-self:end!important}",
"#mz .mz-directory-controls .mz-q,#mz .mz-directory-controls input,#mz .mz-directory-controls select{flex:0 0 auto!important;height:48px!important;min-height:48px!important;max-height:48px!important;align-self:end!important}",
"#mz .mz-directory-controls{align-items:end!important}",
/* 3. the mechanism drawing injected into every idea entry */
"#mz .mz-mechwrap{margin:26px 0 30px}",
"#mz .mz-mechwrap .mz-bsec{display:flex;align-items:center;gap:10px;margin:0 0 12px;font-size:1.4rem;font-weight:700}",
"#mz .mz-mechwrap .mz-bsec svg{width:25px;height:25px;flex:none}",
"#mz .mz-mechwrap .mz-dark,#mz .mz-mechwrap .mz-demo-reading{max-width:720px;margin-inline:auto}",
"#mz .mz-mechwrap h3{font-size:1.4rem;margin:0 0 2px}",
"#mz .mz-mechwrap .mz-cap{margin:0 0 10px!important}",
"#mz .mz-mechwrap .mz-dark{border-radius:18px;padding:12px}",
/* 4. learn panel: give the exploded view room without a dead hole under it */
"#mz .la{max-width:720px!important}",
"#mz .la-l{display:flex;flex-direction:column;align-items:center}",
"#mz .la-l .lw-svg{width:100%;max-width:420px;margin-inline:auto}",
/* 5. small consistency items */
"#mz .tl-rng,#mz .th-era .tl-rng,#mz .mz-era h3{font-variant-numeric:lining-nums}",
"#mz .mz-gc{min-height:170px}",
/* the latin sub-title under an arabic headline was drifting to the far edge */
"#mz-modal .mz-reader-sheet>p.sub{text-align:right}",
"#mz-modal[dir=ltr] .mz-reader-sheet>p.sub,#mz-modal .mz-reader-sheet[dir=ltr]>p.sub{text-align:left}",
/* a one-item table of contents is noise */
"#mz .mz-reading-toc.mz-toc-thin{display:none!important}"
].join('\n');
var s=document.createElement('style');s.id='mz-h-wide2';s.textContent=CSS;document.head.appendChild(s);
})();

/* ---- emblem hues: keep every brand monogram inside the Malichus warm band ---- */
(function(){var MZ=window.MZ;if(!MZ||!MZ.emblem||MZ.__embfix)return;MZ.__embfix=1;
 var o=MZ.emblem;
 MZ.emblem=function(){var r=o.apply(this,arguments);
  if(typeof r!=='string')return r;
  return r.replace(/hsl\(\s*(-?[\d.]+)\s*,/g,function(m,h){
    var v=((parseFloat(h)%360)+360)%360;          /* any hue -> 12..46 (terracotta -> brass) */
    return 'hsl('+(12+(v/360)*34).toFixed(1)+',';
  });};
})();

/* ---- years in era headers were Arabic-Indic while the cards beside them were Western ---- */
(function(){
 var AR='٠١٢٣٤٥٦٧٨٩',
     FA='۰۱۲۳۴۵۶۷۸۹';
 function west(t){var o='';for(var i=0;i<t.length;i++){var c=t[i],j=AR.indexOf(c);if(j<0)j=FA.indexOf(c);o+=(j<0?c:String(j))}return o}
 function run(){try{
  document.querySelectorAll('#mz .tl-rng,#mz .th-era .tl-rng,#mz .mz-era span').forEach(function(e){
   if(e.dataset.nz)return;var t=e.textContent;var w=west(t);if(w!==t)e.textContent=w;e.dataset.nz=1});
 }catch(e){}}
 var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(run,200)}).observe(document.documentElement,{childList:true,subtree:true});
 setTimeout(run,900);
})();

/* ---- hide a table of contents that only has one entry ---- */
(function(){
 function run(){try{
  document.querySelectorAll('#mz .mz-reading-toc').forEach(function(n){
   var k=n.querySelectorAll('a').length;
   n.classList.toggle('mz-toc-thin',k<3);
  });}catch(e){}}
 var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(run,200)}).observe(document.documentElement,{childList:true,subtree:true});
 setTimeout(run,900);
})();

/* ---- exploded-watch figure: shrink the viewBox to what is actually drawn ---- */
(function(){
 function fit(){try{
  document.querySelectorAll('#mz .la-l .lw-svg').forEach(function(svg){
   var g=svg.querySelector('g');if(!g)return;
   var bb;try{bb=g.getBBox()}catch(e){return}
   if(!bb||!bb.height||bb.height<10)return;
   var vb=(svg.dataset.vb0||svg.getAttribute('viewBox')||'').split(/\s+/).map(Number);
   if(vb.length!==4)return;
   if(!svg.dataset.vb0)svg.dataset.vb0=vb.join(' ');
   var pad=10,y=Math.max(vb[1],bb.y-pad),h=Math.min(vb[3]-(y-vb[1]),bb.height+pad*2);
   if(h<40)return;
   var prev=svg.dataset.vbNow||'';var next=vb[0]+' '+y.toFixed(1)+' '+vb[2]+' '+h.toFixed(1);
   if(prev===next)return;svg.dataset.vbNow=next;svg.setAttribute('viewBox',next);
  });
 }catch(e){}}
 var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(fit,160)}).observe(document.documentElement,{childList:true,subtree:true});
 document.addEventListener('input',function(){setTimeout(fit,60)},true);
 setInterval(fit,900);
})();